'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teachingPopoverCarouselPageCountClassNames: function() {
        return teachingPopoverCarouselPageCountClassNames;
    },
    useTeachingPopoverCarouselPageCountStyles_unstable: function() {
        return useTeachingPopoverCarouselPageCountStyles_unstable;
    }
});
const _react = require("@griffel/react");
const teachingPopoverCarouselPageCountClassNames = {
    root: 'fui-TeachingPopoverCarouselPageCount'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Brf1p80: "f4d9j23"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}",
        ".f4d9j23{justify-content:center;}"
    ]
});
const useTeachingPopoverCarouselPageCountStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(teachingPopoverCarouselPageCountClassNames.root, styles.root, state.root.className);
    return state;
};
